let cartElement; 
if (window.location.pathname == '/cart') {
  cartElement = document.querySelector('.cart-sidebar');
} else {
  cartElement = document.querySelector('.drawer');
}

let fetchCartIsRunning = false;

async function fetchCurrentCart() {
  if (fetchCartIsRunning) return;
  fetchCartIsRunning = true;
  let cart = await fetch('/cart', {
    method: 'GET'
    }).then(response => response.text()) 
      .then(html => {
        let parser = new DOMParser();
        let doc = parser.parseFromString(html, 'text/html');
        let cartClass = window.location.pathname == '/cart' ? 'cart-items' : 'cart-drawer-items';
        let fetchedCartSummary = doc.querySelector(cartClass);
        let currentCartSummary = document.querySelector(cartClass);
        if (currentCartSummary && fetchedCartSummary) {
          currentCartSummary.innerHTML = fetchedCartSummary.innerHTML;
        }
      })
      .then(() => {
        fetchCartIsRunning = false;
      })
      .catch(error => {
        console.error('Error fetching or parsing the page:', error);
      });
  return cart;
}

function observeDiscountApp() {
  const discountAppObserver = new MutationObserver((mutationsList, discountAppObserver) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE && node.classList.contains('sc_simple-info')) {
            // console.log('Discount code added');
            setTimeout(() => {
              (async () => {
              const fetchPage = await fetchCurrentCart();
            })();
            }, 1000);
          }
        });
        mutation.removedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE && node.classList.contains('sc_simple-info')) {
            // console.log('Discount code removed');
            setTimeout(() => {
              (async () => {
              const fetchPage = await fetchCurrentCart();
            })();
            }, 2000);
          }
        });
      }
    }
  });

  discountAppObserver.observe(cartElement, {
    childList: true, subtree: true 
  });
}

observeDiscountApp();